export enum RequestTypeEnum {
  InvestmentExceptional = 0,
  Investment = 1,
  NonCatalogProductBudgeted = 2,
  NonCatalogProductNonBudgeted = 3,
  ApplianceLoaner = 4,
  InstrumentsLoaner = 5,
  CatalogProduct = 6,
  TestPosition = 7,
  CatalogExtension = 8,
  HumanResourceRequirement = 9,
  AdvancedTraining = 10,
  TestPositionInvestment = 11,
  StrategicProject = 12,
}
